
/* @ngInject */
export default function geoStateSelectDirective() {
	    return {
	        scope: {
	            filterList: '=',
	        },
	        restrict: 'E',
	        templateUrl: 'app/productCenter/pages/_shared/geoStateSelect/geoStateSelect.html',
	        controller: 'GEOStateSelectController',
	        controllerAs: 'geoState',
	    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/_shared/geoStateSelect/geoStateSelect.directive.js